<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
        >在线文档</span
      >
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData">
      </online-doc>
    </div>
    <!-- 在线文档 END -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import onlineDoc from '../components/onlineDoc'

import { OPEN_API_TEST, OPEN_API_PRO } from '@/constants/index'
const apiUrlTest = 'sms/send'
export default {
  components: { onlineDoc },
  computed: {
    ...mapGetters(['token', 'uuid']),
    address() {
      return this.uuid.length > 0 ? `?uuid=${this.uuid}` : ''
    }
  },
  data() {
    return {
      mainStatus: 'online',
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: '与平台签约的客户，可以通过该接口发送短信，主要用于快递派送过程中根据物流编号发送短信通知。',
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        //参数描述  START
        postDataList: [
          //   请求头参数
          {
            title: 'Headers',
            value: [
              {
                name: 'apiAccount',
                type: 'Number',
                require: 'Y',
                normal: '',
                describe: '接入方在平台的api账户标识'
              },
              {
                name: 'digest',
                type: 'String',
                require: 'Y',
                normal: '',
                describe: '签名字符串'
              },
              {
                name: 'timestamp',
                type: 'Number',
                require: 'Y',
                normal: '',
                describe: '时间戳，毫秒'
              }
            ]
          },
          {
            title: '请求参数',
            value: [
              {
                name: 'bizContent',
                type: 'String',
                require: 'Y',
                normal: '业务参数',
                describe: '业务参数模块内json格式的string类型'
              }
            ]
          },
          {
            title: '业务参数',
            value: [
              {
                name: 'type',
                type: 'String',
                require: 'Y',
                normal: '',
                describe: '短信模板编码'
              },
              {
                name: 'params',
                type: 'String[]',
                require: 'Y',
                normal: '',
                describe: '短信模板变量'
              },
              {
                name: 'waybillNo',
                type: 'String',
                require: 'Y',
                normal: '',
                describe: '运单号'
              },
            ]
          }
        ],
        //参数描述  END
        //报文描述 start
        responseDataList: [
          //   响应参数
          {
            title: '响应参数',
            value: [
              {
                name: 'code',
                type: 'String',
                require: 'Y',
                normal: '',
                describe: '返回码，见附录'
              },
              {
                name: 'msg',
                type: 'String',
                require: 'Y',
                normal: '',
                describe: '描述'
              },
              {
                name: 'data',
                type: 'Object',
                require: 'Y',
                normal: '',
                describe: '业务数据'
              }
            ]
          },
          {
            title: 'data类型说明',
            value: [
              {
                name: 'msgId',
                type: 'String',
                require: 'Y',
                normal: '',
                describe:
                  '短信凭证ID，可作为短信更新回执的凭证'
              }
            ]
          }
        ],
        //请求示例
        requestCode: `Header：
    apiAccount=1627
    digest=U40e5sumorgd3YgZzU61Mw==
    timestamp=1565238848921

Body：
    bizContent= {"type":"1001","params":["测试短信","12000元"],"waybillNo":"123456"}`,
        //返回示例
        responseCode: JSON.parse(`{
    "code": "1",
    "msg": "success",
    "data": [
        {
           "msgId": "341507679191044158"
        }
  ]
}
`),

        //错误代码提示
        errcodeJson: [
          { code: '145003400', msg: '请求失败：当前接口已关闭' },
          { code: '145003401', msg: '您当日请求次数已达上限，请联系管理员解决！' },
          { code: '145003404', msg: '短信模板编码不能为空' },
          { code: '145003405', msg: '短信模板变量不能为空' },
          { code: '145003406', msg: '运单号不能为空' }
        ]
      },

      apiTestData: {
        _headerData: {
          apiAccount: '1001',
          digest: 'U40e5sumorgd3YgZzU61Mw==',
          timestamp: '1565238848921'
        },
        data: {
          bizContent: `{"type":"1001","params":["测试短信","12000元"],"waybillNo":"123456"}`
        },
        //必须要验证的参数
        requestData: ['apiAccount', 'digest', 'timestamp', 'bizContent'],
        textareaData: {
          bizContent: true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: '',
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
        //错误代码提示
        errcodeJson: [
          { code: '145003400', msg: '请求失败：当前接口已关闭' },
          { code: '145003401', msg: '您当日请求次数已达上限，请联系管理员解决！' },
          { code: '145003404', msg: '短信模板编码不能为空' },
          { code: '145003405', msg: '短信模板变量不能为空' },
          { code: '145003406', msg: '运单号不能为空' }
        ]
      }
    }
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../css/apiTest.scss';
</style>
